import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { getEngagedDisengagedEmployee } from "../../../actions/assessment";
import Box from "@mui/material/Box";

export default function EngagedEmployeesGraph({ token, adminCorporateId }) {
  const [engagedYear, setEngagedYear] = useState(new Date().getFullYear());
  const [engagedMonth, setEngagedMonth] = useState(new Date().getMonth() + 1);
  const [engagedData, setEngagedData] = useState([]);
  const [registrationYear, setRegistrationYear] = useState(2022);

  const handleEngagedYearChange = (e) => {
    setEngagedYear(e.target.value);
  };

  const handleEngagedMonthChange = (e) => {
    setEngagedMonth(e.target.value);
  };

  const getEngagedEmployeeData = async () => {
    try {
      const res = await getEngagedDisengagedEmployee(
        token,
        adminCorporateId,
        engagedYear,
        engagedMonth
      );
      setEngagedData(res.data.topEngagedEmployees);
      setRegistrationYear(res.data.year);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEngagedEmployeeData();
  }, [engagedYear, engagedMonth]);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const availableMonths = Array.from({ length: 12 }, (_, i) => i + 1).filter(
    (month) =>
      !(
        engagedYear === new Date().getFullYear() &&
        month > new Date().getMonth() + 1
      )
  );

  return (
    <div className="top-lsst">
      <Typography
        style={{
          marginBottom: "0.3rem",
          fontWeight: "500",
          fontSize: "1.25rem",
          color: "#0D0D0D",
        }}
      >
        Engaged Employees
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <div>
          <Select value={engagedYear} onChange={handleEngagedYearChange}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          >
            {Array.from(
              { length: new Date().getFullYear() - (registrationYear - 1) },
              (_, i) => (
                <MenuItem value={registrationYear + i} key={i}>
                  {registrationYear + i}
                </MenuItem>
              )
            )}
          </Select>
          <Select value={engagedMonth} onChange={handleEngagedMonthChange}
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          >
            {availableMonths.map((month, index) => (
              <MenuItem key={month} value={month}>
                {monthNames[index]}
              </MenuItem>
            ))}
          </Select>
        </div>
      </Box>

      <div className="employees">
        {engagedData.map((employee) => (
          <div
            style={{
              display: "flex",
              backgroundColor: "#FFF",
              borderRadius: "0.38244rem",
              border: "1.224px solid #96A8FF",
              padding: "0.75rem",
              marginBottom: "1rem",
              fontSize: "1rem",
            }}
          >
            <div
              style={{
                background: "#96A8FF",
                fontWeight: "450",
                padding: "4px 1rem",
                borderRadius: "0.19119rem",
              }}
            >
              {" "}
              <Typography>{employee.score}</Typography>
            </div>
            <div
              style={{
                padding: "4px 2rem",
              }}
            >
              <Typography>
                {`${employee.first_name} ${employee.last_name}`}{" "}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
